import { gql } from "@apollo/client";

export const CREATE_DOCUMENT = gql`
  mutation addCustomerDocument(
    $document: DocumentInput!
    $customerId: String!
  ) {
    addCustomerDocument(document: $document, customerId: $customerId) {
      id
      status
      firstName
      lastName
      taxExempted
      phoneNumber {
        phone
        country
      }
      email
      dateOfBirth
      gender
      address
      secondaryPhoneNumber {
        phone
        country
      }
      secondaryEmail
      location {
        street
        city
        state
        country
        zipcode
        fullAddress
      }
      license {
        licenseNumber
        dateOfExpiry
        dateOfIssue
        authority
        endorsement
        offences
        points
        images
      }
      verified
      verificationMethod
      deleted
      profilePicture
      nationalInsuranceNumber
      profession
      documents {
        id
        documentKey
        documentName
        title
        expiryDate
        documentType
        createdAt
      }
      notes {
        id
        description
        createdBy
        createdDate
      }
      accountNumber
      overrideInvoiceDate
      overrideWeeklyInvoiceDate
      weeklyInvoicingDay
      invoicingDay
    }
  }
`;
